module.exports = __webpack_public_path__ + "static/media/image-maximal-strength@2x.53cfec59.png";